import get from 'lodash/get';
import store from '@Store';
import { clearRsSavedLocation } from '@Pages/RetroSynthesis/RetroSynthesisRoot/utils/rsSavedLocation';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { openProjectParametersDialog } from '@Pages/RetroSynthesis/ProjectParametersDialog/action';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfTitlesAbstractsModal } from '@Containers/TitlesAbstractsModal/TitlesAbstractsModalConstants';

export default class SynthesisPlannerService {
  // RT open projects params
  static synthesisProjectAction(structure, databaseId) {
    const rxn = get(structure, 'details.id');
    const molStructure = get(structure, 'molImage.structure');
    store.dispatch(openProjectParametersDialog({ rxn, databaseId, structure: molStructure }));
  }

  // RT clear last RT location and open My projects
  static synthesisProjectCreateAction(history) {
    // clear RS last visited saved location, so it will redirect to my projects page
    clearRsSavedLocation();

    if (history && history.location && RsRoute.isRsLocation(history.location)) {
      history.push(RsRoute.PROJECTS_LIST);
    } else {
      history.push(RsRoute.ROOT);
    }
  }

  /**
   * @ngdoc method
   * @name openTitlesAbstractsDialog
   * @methodOf SynthesisPlanner.SynthesisPlannerService
   * @param {Object} citation
   * @param {Function} goToContext
   * @returns {Object} promise which will be resolved on modal close
   * @description opens titles/abstracts dialog
   */
  static openTitlesAbstractsDialog(citation, goToContext) {
    const modalId = `titlesAbstractsModal-${new Date().valueOf()}`;
    store.dispatch(
      updateDialog({
        id: typeOfTitlesAbstractsModal,
        dialogType: typeOfTitlesAbstractsModal,
        movable: true,
        backdrop: false,
        size: 'xl',
        className: 'titles-abstracts-dialog-wrap',
        citation,
        goToContext,
        modalId,
      })
    );
  }
}
